import React, { FC } from 'react';
import parse from 'html-react-parser';
import { IArticlesSponsored9 } from './params';
import { IArticle } from '../../../types/article';
import Styles from './styles';

import convertToSlug from '../../../utils/convertToSlug';
import { routing } from '../../../translates';

const ArticlesSponsored: FC<{ config: IArticlesSponsored9; articles: IArticle[]; language: string }> = ({
  config,
  articles,
  language,
}) => {
  const cdnUrl = process.env.GATSBY_CDN_URL;

  return (
    <Styles $config={config}>
      <div className="articles-sponsored">
        <div className="container">
          <div className="articles-sponsored-wrapper">
            {articles.map((article, index) => {
              const articleLink = `${routing[language].article}/${convertToSlug(article.name)}-${article.id}/`;
              const imageSrc = `${cdnUrl}/s-${article.imagePath}`;
              const shortDescription = parse(article.description.replace(/(<([^>]+)>)/gi, '').slice(0, 300) || ' ');

              return (
                <a key={article.id} href={articleLink} className="articles-sponsored-article">
                  <div className="articles-sponsored-article-image">
                    <img src={imageSrc} alt={article.name} />
                  </div>
                  <div className="articles-sponsored-article-content-wrapper">
                    <h4 className="articles-sponsored-article-title">{article.name}</h4>
                    {index === 0 ? <p className="articles-sponsored-article-description">{shortDescription}</p> : null}
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </Styles>
  );
};

export default ArticlesSponsored;
